import { findAllPayments, findAllDateGroupPayments, findClientPayments, findAllDateGroupClientPayments } from '../../_services/payments.service';

export const findAllPaymentsEvent = async () => {
    let res = await findAllPayments();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllClientPaymentsEvent = async (cod_client) => {
    let res = await findClientPayments(cod_client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllDateGroupPaymentsEvent = async () => {
    let res = await findAllDateGroupPayments();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllDateGroupClientPaymentsEvent = async (client) => {
    let res = await findAllDateGroupClientPayments(client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}